import {ActionReducerMapBuilder, createSlice} from '@reduxjs/toolkit'
import {SliceStatus, ViolationsDownloadState} from 'interfaces'
import {
  downloadViolationsLogs,
  downloadViolationsLogsFailure,
  downloadViolationsLogsSuccess,
  resetDownloadViolationsLogsState,
} from './actions'

const violationsLogsDownloadInitialState: ViolationsDownloadState = {
  status: SliceStatus.idle,
  fileUrl: '',
}

const violationsLogsDownloadSlice = createSlice({
  name: 'violationsLogsDownload',
  initialState: violationsLogsDownloadInitialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<ViolationsDownloadState>) =>
    builder
      .addCase(downloadViolationsLogs, state => ({
        ...state,
        status: SliceStatus.pending,
      }))
      .addCase(downloadViolationsLogsSuccess, (state, action) => ({
        ...state,
        status: SliceStatus.resolved,
        fileUrl: action?.payload,
      }))
      .addCase(downloadViolationsLogsFailure, state => ({
        ...state,
        status: SliceStatus.rejected,
        fileUrl: '',
      }))
      .addCase(resetDownloadViolationsLogsState, () => ({
        ...violationsLogsDownloadInitialState,
      }))
      .addDefaultCase(state => state),
})

export const {
  reducer: violationsLogsDownloadReducer,
  name: violationsLogsDownloadReducerName,
} = violationsLogsDownloadSlice
